import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { TransactionListInterface } from '../types/transaction-list';
import { TransactionListFilter } from '../types/transaction-list-filter';

export const fetchTransactionList = createAction(
  '[Transaction List] Transaction List Fetch',
  props<{ filter?: TransactionListFilter }>()
);

export const updateTransactionListFilter = createAction(
  '[Transaction Filter] Transaction List update filter',
  props<{ filter?: TransactionListFilter }>()
);

export const loadedTransactionList = createAction(
  '[Transaction List] Transaction List Loaded',
  props<{ dataSource: DataSource<TransactionListInterface[]> }>()
);

export const failedTransactionList = createAction(
  '[Transaction List] Transaction List Failed'
);

export const resetTransactionList = createAction(
  '[Transaction List] Reset Transaction List'
);
